import appInfo from "../app-info";
import { apiHelper } from "./api_helper";

export const tsDictionaryApi = {
    selectAll: () => apiHelper.get(`dictionary`),
}